import React, { useState, useEffect } from "react";

import Design from "./Design";
import {
  fetchBonusData,
  fetchTops,
  fetchWeeklyData1,
  fetchWeeklyData2,
  fetchWeeklyData3,
} from "../../services/api";
const Benefit = () => {
  const [weeklyData1, setWeeklyData1] = useState(null);
  const [weeklyData2, setWeeklyData2] = useState(null);
  const [weeklyData3, setWeeklyData3] = useState(null);
  const [tops, setTops] = useState(null);
  const [bonusData, setBonusData] = useState(null);
  const [flag, setFlag] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      setError(null);
      try {
        const data1 = await fetchWeeklyData1();
        const data2 = await fetchWeeklyData2();
        const data3 = await fetchWeeklyData3();
        const data4 = await fetchTops();
        const data5 = await fetchBonusData();
        setWeeklyData1(data1.data);
        setWeeklyData2(data2.data);
        setWeeklyData3(data3.data);
        setTops(data4.data);
        setBonusData(data5.data);
      } catch (err) {
        setError(err.message);
      } finally {
      }
    };

    fetchData();
  }, [flag]);
  return (
    <div>
      <Design
        bonusData={bonusData}
        tops={tops}
        weeklyData3={weeklyData3}
        weeklyData2={weeklyData2}
        weeklyData1={weeklyData1}
      />
    </div>
  );
};

export default Benefit;
